import EditorComponent from './components/Editor'

export const Editor = EditorComponent
